<generic-button
  [ngClass]="ngClass"
  [buttonNgClass]="buttonNgClass"
  [buttonType]="buttonType"
  [buttonTitle]="debug ? 'Debug' : 'Debug'"
  [iconKey]="iconKey || debug ? 'toggle_on' : 'toggle_off'"
  [color]="color"
  [iconNgClass]="iconNgClass"
  [disabled]="disabled"
  (buttonClick)="changeDebugMode()"
>
</generic-button>
